
import { Linkedin } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen py-12 bg-background">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-foreground">About SSL Solution</h1>
        
        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-lg text-foreground mb-6">
            SSL Solution is a leading provider of business solutions and services, dedicated to helping organizations optimize their operations and achieve their goals through innovative technology solutions.
          </p>
          <p className="text-lg text-foreground mb-6">
            With years of experience in the industry, we have successfully delivered numerous projects across various sectors, helping businesses transform their operations and achieve sustainable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div>
            <h2 className="text-2xl font-bold mb-4 text-foreground">Our Mission</h2>
            <p className="text-foreground">
              To empower businesses with innovative technology solutions that drive growth, efficiency, and success in the digital age.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-4 text-foreground">Our Vision</h2>
            <p className="text-foreground">
              To be the leading technology solutions provider, recognized for excellence, innovation, and customer satisfaction.
            </p>
          </div>
        </div>

        <div className="text-center mb-12">
          <h2 className="text-2xl font-bold mb-6 text-foreground">Connect With Us</h2>
          <div className="flex justify-center space-x-6">
            <a href="https://www.linkedin.com/company/ssl-solution" target="_blank" rel="noopener noreferrer" className="text-foreground hover:text-primary">
              <Linkedin className="h-8 w-8" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
